










/* Created- 27 - Sep - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
import { IssueModel } from "../../../Generated/ParticaAPI";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";

@Component(
	{
		name: "ArticlePageNumber",
		components: { ParticaRowContainer }
	})
export default class ArticlePageNumber extends Vue {
	@Prop() private pageNumber: number; // your data
	@Prop() private issue: IssueModel; // your data
	@Prop() private thumbUrl: string;
	private currentThumb: string = "";
	private nextThumb: string = "";

	private pg: number = 1;
	private changed(event: any) {
		this.currentThumb = this.thumbUrl + this.issue.guid + `/thumb/${this.pg}.300.jpg`;
		this.nextThumb = this.thumbUrl + this.issue.guid + `/thumb/${this.pg + 1}.300.jpg`;

		this.$emit("update:pageNumber", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}
	private getPages() {
		const p: number[] = [];
		if (this.issue !== undefined && this.issue.numberPages !== undefined) {
			for (let i = 0; i < this.issue.numberPages; i++) {
				p.push(i + 1);
			}
		}
		return p;
	}
	private mounted() {
		this.pg = this.pageNumber;
		this.currentThumb = this.thumbUrl + this.issue.guid + `/thumb/${this.pg}.300.jpg`;
		this.nextThumb = this.thumbUrl + this.issue.guid + `/thumb/${this.pg + 1}.300.jpg`;
	}

}
